/**
 * A place to handle common customize icons things
 */
namespace appn.icons {
    export function init() {
        addEvents();
    }

    function addEvents() {
        $('.btn-checkAll').click(function(e) {
            e.preventDefault();
            const $daBox = $(this).closest('.card');
            $daBox.find('.card-body .iconInfo input:checkbox').prop('checked', true);
            appn.fileUploadUtils.enableFileUploadControl($daBox.find('.fileinput'));
        });

        $('.btn-unCheckAll').click(function(e) {
            e.preventDefault();
            const $daBox = $(this).closest('.card');
            $daBox.find('.card-body .iconInfo input:checkbox').prop('checked', false);
            appn.fileUploadUtils.disableFileUploadControl($daBox.find('.fileinput'));
        });

        $('.btn-resetAll').click(function(e) {
            e.preventDefault();
            const $daBox = $(this).closest('.card');
            $daBox.find('.card-body .iconInfo .btn.iconReset').click();
        });

        $('.iconInfo input:checkbox').change(function() {
            if ($(this).is(':checked')) {
                appn.fileUploadUtils.enableFileUploadControl($(this).closest('.iconInfo').find('.fileinput'));
                return;
            }

            appn.fileUploadUtils.disableFileUploadControl($(this).closest('.iconInfo').find('.fileinput'));
        });
    }
}
